import { API, graphqlOperation } from "aws-amplify";
import gql from "graphql-tag";
import { GraphQLResult } from "@aws-amplify/api/lib/types";

export interface Measurement {
  timestamp: string;
  type: string; //This is the type of measurement e.g. "density","mood","flow"
  value: number; //Density, mood, flow , velocity etc. measurements
  text: string; //Used for URLS, etc.
}

interface MeasurementsResult {
  deploymentIds: number[];
  fromTime: Date;
  toTime: Date;
  startOffset: number;
  limit: number;
  more: boolean;
  data: Measurement[];
}

interface Project {
  projectId: string;
  projectName: string | null;
  description: string | null;
}

export interface Site {
  siteId: string;
  siteName: string | null;
  description: string | null;
  address: string | null;
  postcode: string | null;
}

interface Zone {
  zoneId: string;
  zoneName: string | null;
  description: string | null;
  address: string | null;
  latitude: number;
  longitude: number;
}

interface Device {
  deviceId: string;
  deviceName: string | null;
  description: string | null;
  model: string | null;
  serial: string | null;
}

export interface DeploymentInfo {
  deploymentId: number;
  project: Project | null;
  site: Site | null;
  zone: Zone | null;
  device: Device | null;
  measurementType: string;
  deploymentName: string;
  description: string;
}

interface DeploymentsResult {
  deployments: {
    tenantId: string;
    deployments: DeploymentInfo[];
  };
}

const DEPLOYMENTS_QUERY = gql`
  query Deployments($input: DeploymentsInput!) {
    deployments(input: $input) {
      tenantId
      deployments {
        deploymentId
        project {
          projectId
          projectName
          description
        }
        site {
          siteId
          siteName
          description
          address
          postcode
        }
        zone {
          zoneId
          zoneName
          description
          address
          latitude

          longitude
        }
        device {
          deviceId
          deviceName
          description
          model
          serial
        }
        measurementType
        deploymentName
        description
      }
    }
  }
`;

const MEASUREMENTS_QUERTY = gql`
  query MEASUREMENTS($input: MeasurementsInput!) {
    measurements(input: $input) {
      deploymentIds

      fromTime
      toTime
      startOffset
      limit
      more
      data {
        timestamp
        type
        value
        text
      }
    }
  }
`;

class CamerasAPI {
  constructor() {}

  async getDeployments(input: {
    tenantId: string;
  }): Promise<DeploymentsResult> {
    //QUERY AND RETURN DATA
    const deploymentInfo = await API.graphql(
      graphqlOperation(DEPLOYMENTS_QUERY, {
        input: {
          tenantId: input.tenantId,
        },
      })
    );

    const results = (<GraphQLResult>deploymentInfo) as any;
    return results.data;
  }

  async getMeasurements(input: {
    deploymentIds: number[];
    fromTime: Date;
    toTime: Date;
    limit: number;
    offset: number;
  }): Promise<MeasurementsResult> {
    const { deploymentIds, offset, limit } = input;
    const measurementInfo = await API.graphql(
      graphqlOperation(MEASUREMENTS_QUERTY, {
        input: {
          deploymentIds,
          fromTime: input.fromTime.toISOString(),
          toTime: input.toTime.toISOString(),
          offset,
          limit,
        },
      })
    );

    const results = (<GraphQLResult>measurementInfo) as any;
    return results.data.measurements;
  }
}
export default new CamerasAPI();
